import { fDateYMD } from '../../../utils/formatTime';
import { buildQuery } from '../../../utils/query';

// One query builder for the handovers list, so paging and filtering cannot
// send different URLs.
const handoverListQuery = ({
  page = 1,
  rowsPerPage = 10,
  locationId,
  handoverStatus,
  startDate,
  endDate,
  searchTerm,
} = {}) =>
  buildQuery({
    page,
    page_size: rowsPerPage,
    location_id: locationId,
    status: handoverStatus,
    start_date: startDate ? fDateYMD(startDate) : '',
    end_date: endDate ? fDateYMD(endDate) : '',
    search_term: searchTerm,
  });

export default {
  GET_HANDOVERS: (params) => `handovers/${handoverListQuery(params)}`,
  GET_ASSET_MAINTENANCE_RECORDS: ({ id, page = 1, rowsPerPage = 10 }) =>
    `maintenance/?asset_id=${id}&page=${page}&page_size=${rowsPerPage}`,
  GET_HANDOVER_RECORD: (id) => `handovers/${id}`,
  TRANSFER_ASSET: (id) => `assets/${id}/transfer/`,
  CREATE_HANDOVER_RECORD: 'handovers/',
  CREATE_REPAIR_RECORD: 'maintenance/repairs/',
  APPROVE_HANDOVER: (id) => `handovers/${id}/approve/`,
  DECLINE_HANDOVER: (id) => `handovers/${id}/decline/`,
  GET_REPAIR_DETAIL: (id) => `maintenance/repairs/?maintenance_id=${id}`,
  UPDATE_STATUS: (id) => `maintenance/${id}/status`,
  APPROVE_MAINTENANCE: (id) => `maintenance/${id}/approve-maintenance`,
  DECLINE_MAINTENANCE: (id) => `maintenance/${id}/decline-maintenance`,
  RETURN_REQUEST: (id) => `maintenance/${id}/return-request/`,
  ACCEPT_RETURN_REQUEST: (id) => `maintenance/${id}/return-request/accept/`,
  DECLINE_RETURN_REQUEST: (id) => `maintenance/${id}/return-request/decline/`,
  SP_REPAIR_ACCEPTANCE: (id) => `maintenance/${id}/service-provider/accept/`,
  SP_REPAIR_DECLINE: (id) => `maintenance/${id}/service-provider/decline/`,
  DELETE_ASSET: (id) => `assets/${id}/delete/`,
};
